import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/resetpassword/$guid` and `/resetpassword/$guid/$channel`. */
export const Route = createFileRoute('/resetpassword/$guid')({
  component: ResetPasswordGuidLayout,
});

function ResetPasswordGuidLayout() {
  return <Outlet />;
}
